'use strict'
import React from 'react'

import CalendarToolbar     from './CalendarToolbar/CalendarToolbar'
import CalendarPagination  from './CalendarPagination/CalendarPagination'
import OnSchedFullCalendar from './OnSchedFullCalendar/OnSchedFullCalendar'

const OnSchedCalendar = ({ element }) => {
  return (
    <div className='OnSchedCalendar'>
      <CalendarToolbar />
      <CalendarPagination />
      <OnSchedFullCalendar element={element} />
    </div>
  )
}

export default OnSchedCalendar
